import React, { useState, useEffect,useRef } from "react";
import {
    Grid,
    Card,
    CardMedia,
    CardContent,
    Typography,
    Container,
    Avatar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Link,
    Button,
    CircularProgress,
    IconButton
} from "@mui/material";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { getPopularArtists, getEvents, getMyActivity } from "../../../../services/submissionService";
import iconCamera from "../../../../assets/icon-camera.png"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import useStore from "../../../../store/useStore";
import { db } from "../../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const Creator = () => {
    const { userProfile} = useStore();
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [mySales, setMySales] = useState([]);
    const [loading, setLoading] = useState(true);
    // setLoadingId is unused only because both of its call sites in
    // handleResumeClick are commented out; loadingId therefore stays null and
    // the spinner it gates never appears. Restore all three together.
    // eslint-disable-next-line no-unused-vars
    const [loadingId, setLoadingId] = useState(null);

    const navigate = useNavigate();
    const theme = useTheme();


    useEffect(() => {
        const loadEvents = async () => {
            setLoading(true)
            try {
                const data = await getEvents();
                setEvents(data)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.error("Failed to load events", error);
            }
        };
        loadEvents();
    }, []);
    useEffect(() => {
        const loadSpotlight = async () => {
            try {
                const data = await getPopularArtists();
                setUsers(data);
            } catch (error) {
                console.error("Failed to load events", error);
            }
        };
        loadSpotlight();
    }, []);
    useEffect(() => {
        const loadMySales = async () => {
            try {
                const data = await getMyActivity();
                console.log("data..",data)
                setMySales(data);
            } catch (error) {
                console.error("Failed to load events", error);
            }
        }
        loadMySales()
    }, []);

   const handleResumeClick = async (submissionSaleId) => {
    if (!submissionSaleId) return;
    // setLoadingId(submissionSaleId);

    try {
      // Scoped to the signed-in user's own submissions. This is the "resume my
      // draft" path, so the owner filter is correct on its own terms, and it is
      // also what makes the query legal: the rules allow listing a draft only to
      // its owner, and a query that does not constrain the owner is rejected
      // outright rather than filtered down.
      const q = query(
        collection(db, "submissions"),
        where("submissionSaleId", "==", submissionSaleId),
        where("userId", "==", userProfile?.uid)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // ✅ Record found using submissionSaleId
        const foundDoc = querySnapshot.docs[0];
        const docId = foundDoc.id;

        if (docId) {
          navigate(`/upload-artwork?submissionId=${docId}`);
        }
      } else {
        alert("No draft record found for this artwork.");
      }
    } catch (error) {
      console.error("Error fetching draft:", error);
      alert("Failed to fetch draft record. Please try again.");
    } finally {
    //   setLoadingId(null);
    }
  };

    const EventSection = ({ events }) => {

        return (
            <>
                <Typography variant="h4" gutterBottom sx={{ fontFamily: "basic-sans" }}>
                    Events
                </Typography>

                <Grid container spacing={4}>
                    {events.map((event) => {
                        const thumbnailUrl = event.imageSets[0].url || null;
                        return (
                            <Grid
                                onClick={() => {
                                    navigate('/marketplace/event/detail', {
                                        state: { event },
                                    });
                                }
                                }
                                item xs={12} sm={6} md={4} lg={3} key={event.id}>
                                <Card
                                    sx={{
                                        borderRadius: "20px",
                                        backgroundColor: theme.colors.mediumPurple,
                                        color: "white",
                                    }}
                                >
                                    {thumbnailUrl && (
                                        <CardMedia
                                            component="div"
                                            sx={{
                                                paddingTop: "56.25%", // 16:9 aspect ratio
                                                backgroundImage: `url(${thumbnailUrl})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                            }}
                                            alt={event.name || "Content Thumbnail"}
                                        />
                                    )}
                                    <CardContent>
                                        <Typography
                                            variant="h6"
                                            sx={{ fontFamily: "basic-sans", fontWeight: 700 }}
                                        >
                                            {event.name}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </>
        )
    }
    const Spotlight = ({ users }) => {
        const scrollRef = useRef(null);
      
        const scrollLeft = () => {
          scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
        };
      
        const scrollRight = () => {
          scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        };
      
        return (
          <>
            <Typography variant="h4" gutterBottom sx={{ fontFamily: 'basic-sans' }}>
              Spotlight
            </Typography>
      
            <Box sx={{ position: 'relative' }}>
              {/* Left Arrow */}
              <IconButton
                onClick={scrollLeft}
                sx={{
                  position: 'absolute',
                  left: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  backgroundColor: 'white',
                  boxShadow: 1,
                    '&:hover': {
                        backgroundColor: 'white', 
                        boxShadow: 1,
                    },
                }}
              >
                <ChevronLeft />
              </IconButton>
      
              {/* Scrollable User Cards */}
              <Box
                ref={scrollRef}
                sx={{
                  display: 'flex',
                  overflowX: 'auto',
                  scrollBehavior: 'smooth',
                  gap: 2,
                  px: 6, // space for arrow buttons
                  py: 2,
                  '&::-webkit-scrollbar': { display: 'none' },
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {users.map((user) => (
                  <Card
                    key={user.id}
                    onClick={() => navigate(`/challenge/profile/username/${user.userName}`)}
                    sx={{
                      minWidth: 200,
                      flex: '0 0 auto',
                      borderRadius: '20px',
                      backgroundColor: theme.colors.mediumPurple,
                      color: 'white',
                      textAlign: 'center',
                      paddingY: 3,
                      cursor: 'pointer',
                    }}
                  >
                    <Avatar
                      src={user?.kBeanUser?.profilePicture}
                      alt={user.userName}
                      sx={{
                        width: 100,
                        height: 100,
                        margin: '0 auto',
                        borderRadius: '100%',
                        border: '3px solid white',
                      }}
                    />
                    <CardContent>
                      <Typography
                        variant="h6"
                        sx={{
                          fontFamily: 'basic-sans',
                          fontWeight: 700,
                          marginTop: 2,
                        }}
                      >
                        {user.userName}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
      
              {/* Right Arrow */}
              <IconButton
                onClick={scrollRight}
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  backgroundColor: 'white',
                    boxShadow: 1,
                    '&:hover': {
                        backgroundColor: 'white', 
                        boxShadow: 1, 
                    },
                }}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          </>
        );
      };
      const ArtworkList = ({ artworks, type }) => {
        return (
          <Box display="flex" flexDirection="column" gap={2}>
            {artworks.map((art, index) => {
              const isVideo = art?.art?.expectedMediaType === 'Video';
              const preMediaUrl = `${art?.art?.location?.cdnUrl}`;
              const mediaUrl = `${preMediaUrl}${isVideo ? '/_main.mp4' : '/_main.jpg'}`;
      
              return (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    p: 1.5,
                  }}
                >
                  {/* Left side: Media + Text */}
                  <Box display="flex" alignItems="flex-start" gap={2}>
                    {/* Media Preview */}
                    <Box sx={{ width: 100, height: 100, borderRadius: 2, overflow: 'hidden' }}>
                      {isVideo && mediaUrl ? (
                        <video
                          src={mediaUrl}
                          controls
                          controlsList="nodownload noremoteplayback noplaybackrate nofullscreen"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <Avatar
                          src={preMediaUrl ? mediaUrl : iconCamera}
                          variant="square"
                          sx={{ width: 100, height: 100, borderRadius: 2 }}
                        />
                      )}
                    </Box>
      
                    {/* Text Details */}
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {art?.art?.title}
                      </Typography>
      
                      {type === 'draft' && (
                        <>
                          <Typography variant="body2" color="text.secondary">
                            {"Editions pending in market: " + art?.sale?.shares?.totalShares}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {"Price Per Edition: " + art?.sale?.shares?.pricePerShare}
                          </Typography>
                        </>
                      )}
      
                      {type === 'live' && (
                        <>
                          <Typography variant="body2" color="text.secondary">
                            {"Editions in market: " + art?.sale?.shares?.totalShares}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {"Editions sold: " + art?.sale?.shares?.purchasedShares}
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Box>
      
                  {/* Right side: Resume Button (only for draft) */}
                  {type === 'draft' && (
                   loadingId === art?.art?.id ? (
                    <CircularProgress size={24} color="primary" />
                  ) :
                    <Button
                      type="button" 
                      variant="contained"
                      color="primary"
                      sx={{ 
                        borderRadius: 2,
                         textTransform: 'none',
                         backgroundColor:theme.colors.green,
                        "&:hover": {
                            backgroundColor: theme.colors.green,
                            boxShadow: "none",
                          },
                       }}
                      onClick={(e)=>{
                        e.stopPropagation();
                        handleResumeClick(art?.art?.id)}
                    }
                    >
                      Resume
                    </Button>
                  )}
                </Box>
              );
            })}
          </Box>
        );
      };
    const MarketplaceAccordion = () => {
        const [expanded, setExpanded] = useState("draft");

        const handleChange = (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };
        return (
            <Box sx={{ width: '100%', margin: '0 auto', marginTop: 5 }}>
                <Typography variant="h4" gutterBottom sx={{ fontFamily: 'basic-sans' }}>
                    My Sales
                </Typography>
                <Accordion expanded={expanded === "draft"}
                    onChange={handleChange("draft")}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">{"Draft ("+mySales?.draft?.length+")"}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {mySales && mySales?.draft?.length > 0 ?
                            <ArtworkList artworks={mySales?.draft} type={'draft'} />
                            :
                            <Typography>No record found</Typography>
                        }
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">{"Live ("+mySales?.live?.length+")"}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AccordionDetails>
                            {mySales && mySales?.live?.length > 0 ?
                                <ArtworkList artworks={mySales?.live} type={'live'} />
                                :
                                <Typography>No record found</Typography>
                            }
                        </AccordionDetails>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">{"Sold ("+mySales?.sold?.length+")"}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {mySales && mySales?.sold?.length > 0 ?
                            <ArtworkList artworks={mySales?.sold} type={'live'} />
                            :
                            <Typography>No record found</Typography>
                        }
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">{"Processing ("+mySales?.pending?.length+")"}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {mySales && mySales?.pending?.length > 0 ?
                            <ArtworkList artworks={mySales?.pending} type={'live'} />
                            :
                            <Typography>No record found</Typography>
                        }
                    </AccordionDetails>
                </Accordion>
            </Box>
        );
    };



    if (loading) {
        return (
          <Container>
            <Typography variant="body1">Loading...</Typography>
          </Container>
        );
      }
    return (
        <Container maxWidth="xl" sx={{ mt: 4, fontFamily: "basic-sans" }}>
            {events.length > 0 &&
                <EventSection events={events} />
            }
            {users.length > 0 &&
                <Spotlight users={users} />
            }
            {mySales &&
                (
                    mySales?.draft?.length > 0 ||
                    mySales?.live?.length > 0 ||
                    mySales?.sold?.length > 0 ||
                    mySales?.pending?.length > 0) &&
                < MarketplaceAccordion />
            }
 <Box
      sx={{
        position: "fixed", // 👈 sticks to bottom
        bottom: 16,
        left: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        px: 3,
      }}
    >
      {/* Back link */}
      <Link
        component="button"
        underline="none"
        onClick={() => navigate(-1)} // go back
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "1.1em",
          color: "white",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        <ArrowBackIcon sx={{ mr: 0.5 }} />
        Back
      </Link>

      {/* More Info link */}
      <Link
        component="button"
        underline="none"
        onClick={() =>  navigate(`/challenge/profile/${userProfile.uid}`)}
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "1.1em",
          color: "white",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        More Info
        <ArrowForwardIcon sx={{ ml: 0.5 }} />
      </Link>
    </Box>
        </Container>
    );
};

export default Creator;
